/**
 * Doubles internal backticks in every `facetFilters` value so the
 * typesense-instantsearch-adapter — which wraps each value in backticks without
 * escaping internal ones — produces a balanced filter. Without this, a refined
 * facet value containing a backtick yields an odd number of backticks and
 * Typesense rejects the query with "Could not parse the filter query" (JET-2182).
 *
 * Doubling is the correct escape (not a backslash): the adapter's filter
 * tokenizer toggles in/out of a quoted value on every backtick, so a backslash
 * would leave odd parity and a later `(` or `,` in the value would break the
 * query. Field names never contain backticks, so doubling the whole
 * "field:value" entry is safe. Run AFTER reading raw values (e.g.
 * getActiveLocationValues), since it mutates `request.params.facetFilters`.
 */
export function escapeFacetFilterBackticks(request: any) {
  if (!request.params || !Array.isArray(request.params.facetFilters))
    return

  const escapeEntry = (entry: unknown) =>
    typeof entry === "string" ? entry.replace(/`/g, "``") : entry

  request.params.facetFilters = request.params.facetFilters.map((item: unknown) =>
    Array.isArray(item) ? item.map(escapeEntry) : escapeEntry(item),
  )
}
